import { Formik } from 'formik';
import { useState } from 'react';
import Button from '../../../../components/form-control/Button';
import Input from '../../../../components/form-control/Input';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { getEnumsFromState, getSelectedCountry } from '../../../../states/slices/resourceSlice';
import SelectDropdown from '../../../../components/form-control/SelectDropdown';
import { IEnum } from '../../../../resources/interfaces';
import {  getChargetypesEnums, getPortfoliosEnums } from '../../../../api/requests';
import { useQuery } from '@tanstack/react-query';
import TextArea from '../../../../components/form-control/TextArea';
import { capitalizeSentence } from '../../../../utils/miscFunctions';
import { getAllInsurers } from '../../../../services/insurer';

export interface ICoverageTypeConfiguration {
  active?: boolean;
  additionalChargeType?: string;
  additionalChargeValue?: number;
  code?: string;
  insurerId?: number;
  description: string;
  name?: string;
  portfolio?: string;
  id?: number;
}


interface IProps {
  onClose?: () => void;
  onConfirm?: (value: ICoverageTypeConfiguration) => void;
  type?: any;
}

const AddProductModal = ({ onClose, onConfirm, type }: IProps) => {
  const enumsList = useSelector(getEnumsFromState);
  const selectedCountry = useSelector(getSelectedCountry);
  const countryId = selectedCountry?.id ?? 1
  const [portfoliosEnums, setPortfoliosEnums] = useState<IEnum[]>([])
  const [insurers, setInsurers] = useState<any[]>([])
  const [chargeTypesEnums, setChargeTypesEnums] = useState<IEnum[]>([])
  const portfolioKey = type ? type.portfolio.key : ''
    

 const portfoliosEnumlist = async () => {
     await getPortfoliosEnums()
     .then((response:any) => {
       setPortfoliosEnums(response)
     })
     .catch((error:Error) => console.log(error))
   }
 
  const chargeTypesEnumlist = async () => {
     await getChargetypesEnums()
     .then((response:any) => {
       setChargeTypesEnums(response)
     })
      .catch((error:Error) => console.log(error))
   }

  const insurerslist = async () => {
     await getAllInsurers(countryId)
     .then((response:any) => {
       
       setInsurers(response.data)
     })
     .catch((error:Error) => console.log(error))
   }
 
  useQuery({queryKey:['portfoliosEnumlist'], queryFn:portfoliosEnumlist})
  useQuery({queryKey:['chargeTypesEnumlist'], queryFn:chargeTypesEnumlist})
  useQuery({queryKey:['insurerslist'], queryFn:insurerslist})

  const initialValues: ICoverageTypeConfiguration = {
    active: type ? type?.active : true,
    additionalChargeType: type ? type?.additionalChargeType.key : '',
    additionalChargeValue: type ? type?.additionalChargeValue : undefined,
    code: type ? type?.code : '',
    insurerId: type ? type?.insurerId : undefined,
    description: type ? type.description : '',
    name: type ? type?.name : '',
    portfolio: type ? type?.portfolio?.key : ''
  };


  return (
    <div className="bg-white P-6 rounded-2xl dark:!text-darkBg-mainText dark:bg-darkBg">
      <div className="py-6 px-3 md:px-6  w-full">
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validateOnChange={true}
          validateOnBlur={true}
        validationSchema={ Yup.object().shape({

        additionalChargeType: Yup.string()
          .required('Additional Charge Type is required.'),

        additionalChargeValue: Yup.number()
          .typeError('Additional Charge Value must be a number')
          .required('Additional Charge Value is required.'),

        code: Yup.string()
          .required('Code is required.'),

        description: Yup.string()
          .required('Description is required.'),

        name: Yup.string()
          .required('Name is required.'),

        portfolio: Yup.string()
          .required('coverage is required.')
      })}
          onSubmit={async (values: ICoverageTypeConfiguration, { resetForm }) => {
                const payload = {
                   active: true,
                  additionalChargeType: values.additionalChargeType,
                  additionalChargeValue: values.additionalChargeValue,
                  code: values.code,
                  insurerId: values.insurerId,
                  description: values.description,
                  name: values.name,
                  portfolio: values.portfolio
                 
                }
                onConfirm?.(payload)
             
          }}>
          {({
            values,
            errors,
            isSubmitting,
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            touched
          }) => (
            <form className="" onSubmit={handleSubmit}>
              <div className=" ">
                <div className="w-full grid grid-cols-2 gap-3">
                   <Input
                    type={'text'}
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Name"
                    placeholder="Enter name"
                    required
                    error={touched.name ? errors.name : undefined}
                    helperText={touched.name ? errors.name : undefined}
                    className="rounded"
                  />

                  <SelectDropdown
                    name="portfolio"
                    listSelectedValue={values.portfolio}
                    onChange={(value: string) => {
                      setFieldValue('portfolio', value);
                    }}
                    label="Coverage"
                    placeholder="Select coverage"
                    list={portfoliosEnums?.map((portfolio: IEnum) => ({
                      name: `${capitalizeSentence(portfolio.title)}`,
                      value: `${portfolio.key}`
                    }))}
                    required
                    error={touched.portfolio ? errors.portfolio : undefined}
                    helperText={touched.portfolio ? errors.portfolio : undefined}
                    selectInputClassName="rounded"
                  />


                  <Input
                    type={'number'}
                    name="additionalChargeValue"
                    value={values.additionalChargeValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Additional Charge Value"
                    placeholder="Enter charge value"
                    required
                    error={touched.additionalChargeValue ? errors.additionalChargeValue : undefined}
                    helperText={touched.additionalChargeValue ? errors.additionalChargeValue : undefined}
                    className="rounded"
                  />
 
                   <SelectDropdown
                    name="additionalChargeType"
                    listSelectedValue={values.additionalChargeType}
                    onChange={(value: string) => {
                      setFieldValue('additionalChargeType', value);
                    }}
                    label="Additional Charge Type"
                    placeholder="Select charge type"
                    list={chargeTypesEnums?.map((charge: IEnum) => ({
                      name: `${charge.title}`,
                      value: `${charge.key}`
                    }))}
                    required
                    error={touched.additionalChargeType ? errors.additionalChargeType : undefined}
                    helperText={touched.additionalChargeType ? errors.additionalChargeType : undefined}
                    selectInputClassName="rounded"
                  />

                  <Input
                    type={'text'}
                    name="code"
                    value={values.code}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Code"
                    placeholder="Enter code"
                    required
                    error={touched.code ? errors.code : undefined}
                    helperText={touched.code ? errors.code : undefined}
                    className="rounded"
                  />

                   <SelectDropdown
                    name="insurerId"
                    listSelectedValue={values.insurerId}
                    onChange={(value: string) => {
                      setFieldValue('insurerId', value);
                    }}
                    label="Company"
                    placeholder="Select a company"
                    list={insurers?.map((charge: any) => ({
                      name: `${charge.name}`,
                      value: charge.id
                    }))}
                    // error={touched.insurerId ? errors.insurerId : undefined}
                    // helperText={touched.insurerId ? errors.insurerId : undefined}
                    selectInputClassName="rounded"
                  />


                   
 

                </div>
                 <div className='mt-4'>
                <TextArea
                label='Description'
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter description"
                        required
                        error={
                          touched.description && errors.description !== undefined
                            ? String(errors.description)
                            : undefined
                        }
                        helperText={
                          touched?.description && errors.description !== undefined
                            ? String(errors.description)
                            : undefined
                        }
                        rows={6}
                        max={1000}
                      />
              </div>
               </div>
              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                />
                <Button
                  label="Submit"
                  type='submit'
                  bgColor='primary'
              fullWidth
                  //   loading={submitting}
                  //   disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddProductModal;
